export const ADMIN_FINANCE_MONTH_DEDUCTION_ROUTE_NAME = Symbol('admin.finance.month.deduction');

export const ADMIN_FINANCE_MONTH_DEDUCTION_URL = 'admin/bookkeepings/show_deduction';
export const FINANCE_MONTH_DEDUCTION_QUERY_KEY = 'finance.month.deduction';

export const ADMIN_FINANCE_MONTH_DEDUCTION_SAVE_URL = 'admin/bookkeepings/deduction';
export const FINANCE_MONTH_DEDUCTION_SAVE_MUTATION_KEY = 'finance.month.deduction.save';
